import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { UserRole, useAuth } from './AuthProvider';

type ProtectedRouteProps = {
    role: UserRole;
};

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ role }) => {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 10, gap: 2 }}>
                <CircularProgress />
            </Box>
        );
    }

    if (!user || user.role !== role) {
        if (role === 'admin' && user?.role === 'owner') {
            return <Navigate to="/puppy-owners" replace />;
        }
        const signInPath = role === 'admin' ? '/puppy-owners?admin' : '/puppy-owners';
        return <Navigate to={signInPath} replace state={{ from: location.pathname }} />;
    }

    return <Outlet />;
};

export default ProtectedRoute;
